
(function ($) {

    $.GridView = function (element, options) {
        
        const addButtonType = {
            None: '914a4421-e9fc-4e49-b401-4276ae0256aa',
            Dialog: '6c5e9114-06fe-43bc-9bc5-9427f667ec5d',
            Inline: '6cd19327-f94b-4a9e-a7ae-fbf1481ee918'
        };
        const editButtonType = {
            None: '914a4421-e9fc-4e49-b401-4276ae0256aa',
            Dialog: '6c5e9114-06fe-43bc-9bc5-9427f667ec5d',
            Form: '90f49355-681e-4a63-85f2-7fe3bd5af14d'
        };

        var defaults = {

            // references to buttons
            addButton: null,
            editButton: null,
            removeButton: null,

            // grid edit mode configuration
            isInlineEditable: false,
            addButtonType: addButtonType.None,
            editButtonType: editButtonType.None,
            hasDeleteButton: false,

            // callbacks
            addButtonClickCallback: function (grid) {

                if (plugin.settings.addButtonType === addButtonType.Inline) {

                    let $row = addRowPrivate();
                    
                    // Set dirty flag on main form container
                    console.log('CHANGED: ' + grid.attr('form-table-id'));
                    var form = $row.closest('form.main-form');
                    var dialog = $row.closest('.form-horizontal');
                    if (form.length > 0) {
                        form.attr('data-is-dirty', true);
                    } else if( dialog.length > 0) {
                        dialog.attr('data-is-dirty', true);
                    }

                    
                }
                else if (plugin.settings.addButtonType === addButtonType.Dialog) {

                    let parentId = grid.attr('parent-id');
                    let parentEntityAttributeId = grid.data('parent-entity-attribute-id');
                    let entityId = grid.attr('edit-entity');
                    let formTableId = grid.attr('form-table-id');
                    let parentEntityId = grid.data('parent-entity-id');
                    let formGroupId = grid.attr('custom-form-group-id');
                    let formFieldId = grid.attr('data-formfield-id');
                    if (plugin.settings.lightBoxUrl) {
                        let url = plugin.settings.lightBoxUrl + '?parentId=' + parentId + '&id=&entityId=' + entityId + '&formTableId=' + formTableId + '&parentEntityId=' + parentEntityId + '&formFieldId=' + formFieldId;
                        $.agito.hrmPage.loadDialog(url);
                    }
                    else {
                        $.agito.hrmPage.quickEditDialog(entityId, null, parentEntityAttributeId, parentId, function (result) {

                            $.agito.hrmPage.handleAjaxError('.hrm-page-messages-placeholder:first', result);

                            if (result.success)
                                $('[form-table-id="' + formTableId + '"]').GridView().RefreshRowFromServer(result.entityInstanceId);
                        }, formGroupId);
                    }
                }
            },

            editButtonClickCallback: function (ids, grid) {
                
                if (ids == null || ids.length !== 1)
                    return;

                let id = ids[0];
                
                if (plugin.settings.editButtonType === editButtonType.Dialog) 
                    EditRow(id, false);
                else if (plugin.settings.editButtonType === editButtonType.Form)
                    EditRow(id, true);
            },

            deleteButtonClickCallback: function(id, grid) {
                
                RemoveRowsWithDeleteDialog();
            },

            // other stuff
            linkClickCallback: null,
            createRowCallback: null,
            selectionChangedCallback: null,

            rowTemplate: null,
            lightBoxUrl: null,
            formUrl: null,
            refreshRowFromServerUrl: null,
            mnUrl: null,
            sortable: false,
            allowAdd: true,
            allowEdit: true,
            allowDelete: true,
            allowView: true,
            selectionChangedCallbacks: []
        }
        
        var plugin = this;
        plugin.settings = {}

        var $element = $(element);
        var nextRowIndex = 0;

        plugin.init = function () {

            plugin.settings = $.extend({}, defaults, options);
            

            // save and then remove template row
            if (typeof options.rowTemplate === 'undefined') {
                var template = $element.find('tr.template');

                if (template.length === 1) {
                    template.detach();

                    options.rowTemplate = template[0].outerHTML;
                }
            }


            // disable add button, if add is not permitted (by security)
            if (!options.allowAdd && options.addButton) {
                options.addButton.prop('disabled', true);
                options.addButton.toggleClass('disabled', true);
            }

            // hide add button, if add button type = none
            if ((!options.addButtonType || options.addButtonType === addButtonType.None) && options.addButton)
                options.addButton.hide();

            // disable edit button, if edit is not permitted (by security)
            if (!options.allowEdit && options.editButton) {
                options.editButton.prop('disabled', true);
                options.editButton.toggleClass('disabled', true);
            }

            // hide edit button, if edit button type = none
            if ((!options.editButtonType || options.editButtonType === editButtonType.None) && options.editButton)
                options.editButton.hide();

            // disable delete button, if delete is not permitted (by security)
            if (!options.allowDelete && options.removeButton) {
                options.removeButton.prop('disabled', true);
                options.removeButton.toggleClass('disabled', true);
            }

            // hide delete button, if has delete button = false
            if ((!options.hasDeleteButton || options.hasDeleteButton === false) && options.removeButton)
                options.removeButton.hide();
           

            // disable buttons if they are dialog editable and parent entity hasn't been saved yet
            if ($element.attr('edit-entity') !== '' && !$element.attr('parent-id')) {

                if (options.addButtonType === addButtonType.Dialog && options.addButton) {
                    options.addButton.prop('disabled', true);
                    options.addButton.toggleClass('disabled', true);
                }

                if (options.editButtonType === editButtonType.Dialog && options.editButton) {
                    options.editButton.prop('disabled', true);
                    options.editButton.toggleClass('disabled', true);
                }
            }


            // select row on click
            $element.on('click', 'tbody tr', function () {
                //Remove active from rows before
                $(this).siblings().removeClass("selected");
                $(this).siblings().find('.selector [type=checkbox]').prop("checked", false);
                $(this).siblings().find('.selector [type=checkbox]').trigger('change');

                //this row becomes selected
                $(this).addClass("selected");
                $(this).closest('tr').find('.selector [type=checkbox]').prop("checked", true);
                $(this).closest('tr').find('.selector [type=checkbox]').trigger('change');
                plugin.updateHeaderCheckbox();
                selectionChangedInternal();
            });

            // select row on checkbox click
            $element.on('click', 'td.selector input:checkbox', function (e) {
                if ($(this).closest('tr').hasClass('selected')) {
                    //Remove selected, click on same item
                    $(this).closest('tr').removeClass('selected');
                    $(this).closest('.selector [type=checkbox]').prop('checked', false);
                    plugin.updateHeaderCheckbox();
                    selectionChangedInternal();
                    e.stopPropagation();//cancel parent event click
                }
                else {
                     //this row becomes selected
                    $(this).closest('tr').addClass("selected");
                    $(this).closest('.selector [type=checkbox]').prop("checked", true);
                    plugin.updateHeaderCheckbox();
                    selectionChangedInternal();
                    e.stopPropagation();//cancel parent event click
                }
            });

            // select all rows
            $element.on("click", "th.selector input:checkbox", function () {

                var headerCheckBox = $(this);
                var children = $element.find("tr:visible td.selector input:checkbox");
                children.prop('checked', headerCheckBox.is(':checked'));
                children.trigger('change');


                if (headerCheckBox.is(':checked')) {
                    $element.find("tbody tr").addClass('selected');
                }
                else {
                    $element.find("tbody tr").removeClass('selected');
                }
                selectionChangedInternal();
            });

            $element.on("click", "td.selector input:checkbox", function () {
                plugin.updateHeaderCheckbox();
                selectionChangedInternal();
            });


            // link click action (usually in first column)
            $element.on("click", "td.edit-link", function () {

                let id = $(this).closest('tr').attr('key');

                if (options.linkClickCallback)
                    // TODO: OBSOLETE callback - to be removed!
                    options.linkClickCallback(id);
                else
                    plugin.settings.editButtonClickCallback.call($element, [id], $element);
            });

            // row double click
            $element.on('dblclick', 'tbody tr', function (e) {

                let id = $(this).attr('key');

                if (!id)
                    id = $(this).attr('data-key');

                plugin.settings.editButtonClickCallback.call($element, [id], $element);
            });

            // add button click
            if (options.addButton) {
                
                options.addButton.click(function() {
                    plugin.settings.addButtonClickCallback.call($element, $element);
                });
            }

            // edit button click           
            if (options.editButton) {

                options.editButton.click(function() {

                    let ids = plugin.GetSelectedIds();
                    plugin.settings.editButtonClickCallback.call($element, ids, $element);
                });
            }

            // remove button click
            if (options.removeButton) {

                options.removeButton.click(function () {

                    let ids = plugin.GetSelectedIds();
                    plugin.settings.deleteButtonClickCallback.call($element, ids, $element);
                });
            }
            

            // init sortable picker on sortable grids
            if (options.sortable) {
                $element.find('tbody')
                    .sortable({
                        handle: '.selector'
                    });
            }

            nextRowIndex = $element.find("tr").length - 1;

            selectionChangedInternal();

            displayPermissions();
        }

        /*
        plugin.AddMNRow = function (ids) {

            var parentId = $element.attr('parent-id');
            var formTableId = $element.attr('form-table-id');

            var url = options.mnUrl;

            var $this = this;

            $.ajax({
                type: "POST",
                url: url,
                contentType: 'application/json',
                data: JSON.stringify({ formTableId: formTableId, parentId: parentId, ids: ids }),
                success: function (data) {

                    if (data != null && data.success) {
                        $.each(data.ids, function (index, value) {
                            $this.RefreshRowFromServer(value);
                        });
                    }
                    else {
                        alert(data.message);
                    }
                }
            });
        };*/

        var setNextRowIndex = function (data) {

            nextRowIndex++;

            var tableName = $element.attr('id');

            var nameOld = tableName + '[0]';
            var nameNew = tableName + '[' + nextRowIndex + ']';

            var idOld = tableName + '_0__';
            var idNew = tableName + '_' + nextRowIndex + '_';

            var row = $(data);

            row.find("*")
                .each(function () {
                    var $this = $(this);

                    if (typeof $this.attr('name') !== 'undefined')
                        $this.attr('name', $this.attr('name').replace(nameOld, nameNew));

                    if (typeof $this.attr('id') !== 'undefined')
                        $this.attr('id', $this.attr('id').replace(idOld, idNew));
                });

            row.find("[name$='" + tableName + ".Index']").val(nextRowIndex);

            return row;
        }

        plugin.RefreshRowFromServer = function (id) {

            var parentId = $element.attr('parent-id');
            var formTableId = $element.attr('form-table-id');
            var formId = $element.attr('form-id');
            var entityName = $element.attr('edit-entity');

            var url = options.refreshRowFromServerUrl + '?parentId=' + parentId + '&id=' + id + '&formTableId=' + formTableId + '&formId=' + formId;

            $.get(url, null, function (data) {

                var existingRow = $element.find('tr[key="' + id + '"]');
                var $data = setNextRowIndex(data);

                if (existingRow.length === 0) {
                    $data.appendTo($element).removeClass('template');
                }
                else {
                    existingRow.replaceWith($data);
                    $data.removeClass('template');
                }

                $data.stop().css("background-color", "#888888").animate({ backgroundColor: "#FFFFFF" }, 1000);
                
                // (re)init controls
                $("form").removeData("validator");
                $("form").removeData("unobtrusiveValidation");
                $.validator.unobtrusive.parse("form");

                $.agito.igHelper.initializeIgEditors('#' + $element.attr('id'));
                $.agito.controlsHelper.initializeAgitoControls('#' + $element.attr('id'));

                updateGridVisibility();
            });
        },

        plugin.RefreshRow = function (id, data) {

            var row = setNextRowIndex(data);

            //////////

            var existingRow = $element.find('tr[key="' + id + '"]');
            var $data = row;
            if (existingRow.length === 0) {
                $data.appendTo($element).removeClass('template');
            }
            else {
                existingRow.replaceWith($data);
                $data.removeClass('template');
            }

            //////////

            // (re)init controls
            $("form").removeData("validator");
            $("form").removeData("unobtrusiveValidation");
            $.validator.unobtrusive.parse("form");

            $.agito.igHelper.initializeIgEditors('#' + $element.attr('id') + ' tr:last-child');
            $.agito.controlsHelper.initializeAgitoControls('#' + $element.attr('id') + ' tr:last-child');

            plugin.updateHeaderCheckbox();
            selectionChangedInternal();

            $data.stop().css("background-color", "#888888").animate({ backgroundColor: "#FFFFFF" }, 1000);

            updateGridVisibility();
        }

        plugin.GetNextRowIndex = function()
        {
            return nextRowIndex;
        }

        plugin.GetSelectedIds = function () {

            var ids = [];

            $element.find("td.selector input:checkbox:checked").each(function () {
                var id = $(this).closest('tr').attr('key');
                if (id && id !== '00000000-0000-0000-0000-000000000000')
                    ids.push(id);
            });

            return ids;
        }

        plugin.GetEntityId = function () {
            return $element.attr('edit-entity');
        }

        plugin.AddRow = function()
        {
            addRowPrivate();
        }

        var RemoveRowsWithDeleteDialog = function () {
            var formTableId = $element.attr('form-table-id');

            // Remove new not saved rows
            $element.find('tr[key="00000000-0000-0000-0000-000000000000"] td.selector input:checkbox:checked, tr:not([key]) td.selector input:checkbox:checked, tr[key=""] td.selector input:checkbox:checked').each(function () {
                $(this).closest('tr').remove();
                
                plugin.updateHeaderCheckbox();
                selectionChangedInternal();
            });

            // Find other saved rows to remove
            var ids = plugin.GetSelectedIds();
            var entityId = plugin.GetEntityId();

            if (ids.length > 0) {
                //Show modal dialog for delete
                $.agito.hrmPage.openDeleteDialog(entityId, ids, ids.length, function($modal) {
                    // SUCCESS
                    plugin.RemoveRows();

                    plugin.updateHeaderCheckbox();
                    selectionChangedInternal();
                    // Set dirty flag on main form container
                    console.log('CHANGED: ' + formTableId);
                    var form = $element.closest('form.main-form');
                    var dialog = $element.closest('.form-horizontal');
                    if (form.length > 0) {
                        form.attr('data-is-dirty', true);
                    } else if( dialog.length > 0) {
                        dialog.attr('data-is-dirty', true);
                    }
                }, null, formTableId, false);
            }
        }

        plugin.RemoveAllRows = function () {
            var removedRows = false;
            $('tbody', $element).empty();
            removedRows = true;

            if (removedRows) {
                plugin.updateHeaderCheckbox();
                selectionChangedInternal();
            }
        }

        plugin.RemoveRows = function () {

            var removedRows = false;

            $element.find("td.selector input:checkbox:checked").each(function () {
                $(this).closest('tr').remove();
                removedRows = true;
            });

            if (removedRows) {
                plugin.updateHeaderCheckbox();
                selectionChangedInternal();
            }

            return;
        }

        
         //Adds button to grid.
         //@param {} position - where the button is appended to toolbar. 0 = beginning, null = end.
         //@param {} title - title of the button.
         //@param {} iconClass - iconClass of the button.
         //@param {} onSelectionChanged - callback to be called on grid selection changed. Callback has two parameters, selectedItems -> array of selected items, grid -> jQuery reference to grid. "this" is a jquery reference to button.
         //@param {} onClick - callback to be called on button click. Callback has two parameters, selectedItems -> array of selected items, grid -> jQuery reference to grid. "this" is a jquery reference to button.
         
        plugin.AddButton = function (position, title, iconClass, onSelectionChanged, onClick, buttonId) {
            let $buttonContainer = $element.prevAll('.grid-container-header:first').find('.pull-right');

            if ($buttonContainer.length === 0)
                throw 'Cannot add grid button: Grid does not have a (supported) header row with buttons.';

            title = title ? title : '';
            buttonId = buttonId ? buttonId : '';

            let $button = $('' +
                '<button class="btn" id="' + buttonId + '" type="button">' +
                    '<span title="'+ title + '" class="' + iconClass + '"></span>' +
                    '<span class="btn-text">' + title + '</span>' +
                '</button>');

            // insert button to toolbar
            if (position === 0)
                $buttonContainer.prepend($button);
            else if (!position || position >= $buttonContainer.children().length)
                $buttonContainer.append($button);
            else
                $($buttonContainer.children()[position - 1]).after($button);

            // register onSelectionChanged callback
            if (onSelectionChanged)
                plugin.settings.selectionChangedCallbacks.push({ callback: onSelectionChanged, element: $button });

            // register onClick callback
            if (onClick)
                $button.click(function () {
                    onClick.call($button, plugin.GetSelectedIds(), $element);
                });

            // call selection changed to init button initial state
            if (onSelectionChanged)
                onSelectionChanged.call($button, plugin.GetSelectedIds(), $element);
        }

        var EditRow = function (id, openInForm) {

            var parentId = $element.attr('parent-id');
            var entityId = $element.attr('edit-entity');

            var formTableId = $element.attr('form-table-id');
            var formId = $element.attr('form-id');
            var formFieldId = $element.attr('data-formfield-id');

            var formGroupId = $element.attr('custom-form-group-id');

            var parentEntityAttributeId = $element.data('parent-entity-attribute-id');
            var parentEntityId = $element.data('parent-entity-id');
       
            if (openInForm) {

                var formUrl = options.formUrl;
                formUrl += '?entityId=' + entityId;
                formUrl += '&entityInstanceId=' + id;

                UrlHelpers.OpenBrowserTab(formUrl);

            } else {

                if (plugin.settings.lightBoxUrl) {
                    var url = plugin.settings.lightBoxUrl + '?parentId=' + parentId + '&id=' + id + '&entityId=' + entityId + '&formTableId=' + formTableId + '&formId=' + formId + '&parentEntityId=' + parentEntityId + '&formGroupId' + formGroupId + '&formFieldId=' + formFieldId;
                    $.agito.hrmPage.loadDialog(url);
                }
                else {
                    $.agito.hrmPage.quickEditDialog(entityId, id, parentEntityAttributeId, parentId, function (result) {

                        $.agito.hrmPage.handleAjaxError('.hrm-page-messages-placeholder:first', result);

                        if (result.success)
                            $('[form-table-id="' + formTableId + '"]').GridView().RefreshRowFromServer(result.entityInstanceId);
                    }, formGroupId);
                }
            }
            
        }

        plugin.updateHeaderCheckbox = function() {

            var checkBoxes = $element.find("tr:visible td.selector input:checkbox");
            var checked = $element.find("tr:visible td.selector input:checkbox:checked");
                
            var headerChecked = checkBoxes.length === checked.length && checked.length > 0;

            $element.find("th.selector input:checkbox").prop('checked', headerChecked);
        }

        var updateGridVisibility = function () {
            var gridVisible = $element.find('tr').length > 1;
            var containerPictures = $element.closest('.gridview-container').find('.container-pictures');
            var toolbar = $element.closest('.gridview-container').find('.grid-toolbar');

            if (gridVisible) {
                toolbar.css('display', 'block');
                containerPictures.css('display', 'none');
            }
            else {
                toolbar.css('display', 'none');
                containerPictures.css('display', 'flex');
            }
        }

        var addRowPrivate = function () {

            nextRowIndex++;

            var tableName = $element.attr('id');

            var nameOld = tableName + '[0]';
            var nameNew = tableName + '[' + nextRowIndex + ']';

            var idOld = tableName + '_0__';
            var idNew = tableName + '_' + nextRowIndex + '_';

            var row = $(options.rowTemplate);

            row.find("*").each(function ()
            {
                var $this = $(this);

                if(typeof $this.attr('name') !== 'undefined')
                    $this.attr('name', $this.attr('name').replace(nameOld, nameNew));

                if (typeof $this.attr('id') !== 'undefined')
                    $this.attr('id', $this.attr('id').replace(idOld, idNew));

                if (typeof $this.attr('lookup-target') !== 'undefined')
                    $this.attr('lookup-target', $this.attr('lookup-target').replace(nameOld, nameNew));

                if ($this.attr('data-name') != null)
                    $this.attr('data-name', $this.attr('data-name').replace(nameOld, nameNew));
            });

            row.find("[name$='" + tableName + ".Index']").val(nextRowIndex);
            
            row.removeClass('template').appendTo($element);

            $("form").removeData("unobtrusiveValidation");
            $("form").removeData("validator");
            $.validator.unobtrusive.parse("form");
 
            $.agito.igHelper.initializeIgEditors('#' + $element.attr('id') + ' tr:last-child');
            $.agito.controlsHelper.initializeAgitoControls('#' + $element.attr('id') + ' tr:last-child');
            plugin.updateHeaderCheckbox();
            selectionChangedInternal();

            updateGridVisibility();

            return row;
        }

        var selectionChangedInternal = function () {
            
            var checked = $element.find("td.selector input:checkbox:checked");

            if(options.allowDelete && options.removeButton)
            {
                options.removeButton.prop('disabled', checked.length === 0);
                options.removeButton.toggleClass('disabled', checked.length === 0);
            }

            if (options.editButton)
            {
                options.editButton.prop('disabled', checked.length !== 1);
                options.editButton.toggleClass('disabled', checked.length !== 1);
            }

            if (plugin.settings.selectionChangedCallback)
            {
                var ids = [];

                $element.find("td.selector input:checkbox:checked").each(function(){
                    ids.push($(this).closest('tr').attr('key'));
                });

                plugin.settings.selectionChangedCallback(ids);
            }

            if (plugin.settings.selectionChangedCallbacks) {
                let selectedIds = plugin.GetSelectedIds();

                plugin.settings.selectionChangedCallbacks.forEach(function (entry) {
                    entry.callback.call(entry.element, selectedIds, $element);
                });
            }
            
        }

        var displayPermissions = function () {

        if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
                $element.append(
              '<div style="position: absolute; top: 0; left: 0;">' +
                  'Permissions: &nbsp;' +
                  'View: ' + options.allowView +
                  '&nbsp;|&nbsp; Add: ' + options.allowAdd +
                  '&nbsp;|&nbsp; Delete: ' + options.allowDelete +
                  '&nbsp;|&nbsp; Edit: ' + options.allowEdit +
              '</div>');
            }
          
        }

        plugin.init();
    }

    // add the plugin to the jQuery.fn object
    $.fn.GridView = function (options) {
        
        if (undefined === $(this).data('GridView'))
        {
            var plugin = new $.GridView(this, options);
            $(this).data('GridView', plugin);
            return plugin;
        }
        else
        {
            return $(this).data('GridView');
        }
    }

})(jQuery);
